import React from 'react';
import { BandMember } from '../types';
import BandMemberCard from './BandMemberCard';
import '../styles/components/BandMemberList.css';

interface BandMemberListProps {
  members: BandMember[];
  showFullContent?: boolean;
}

const BandMemberList: React.FC<BandMemberListProps> = ({ members, showFullContent = false }) => {
  return (
    <div className="band-members">
      {members.map((member) => (
        <BandMemberCard
          key={member.id}
          member={member}
          showFullContent={showFullContent}
        />
      ))}
    </div>
  );
};

export default BandMemberList;
